import type { ModuleTagEntry } from './index';

/** Image Plane module tags. */
export const tags: ModuleTagEntry[] = [
  'ImagerPixelSpacing',
  'ImageOrientationPatient',
  'ImagePositionPatient',
  'SpacingBetweenSlices',
  'SliceThickness',
  'SliceLocation',
];
